import { render } from "./LoadInfo.vue?vue&type=template&id=ddad68ae&scoped=true"
import script from "./LoadInfo.vue?vue&type=script&lang=js"
export * from "./LoadInfo.vue?vue&type=script&lang=js"

import "./LoadInfo.vue?vue&type=style&index=0&id=ddad68ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddad68ae"]])

export default __exports__